export default __webpack_public_path__ + "img/stop-sharing.15125643.svg";